import { Chip, Stack } from '@mui/material'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline'
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline'
import {
  derivePractitionerEnabled,
  getKycStatusMeta,
} from 'src/supportPortal/utils/practitionerStatus'

/**
 * Compact enabled/disabled + KYC status chips for a practitioner. Used on the listing rows,
 * the profile drawer header and the practitioner detail page so the same visual language
 * shows up everywhere a practitioner is rendered.
 */
export default function PractitionerStatusChips({
  practitioner,
  enabled,
  kycStatus,
  practitionerLabel = 'Practitioner',
  size = 'small',
  showKyc = true,
}) {
  const isEnabled =
    typeof enabled === 'boolean' ? enabled : derivePractitionerEnabled(practitioner)
  const resolvedKyc = kycStatus ?? practitioner?.kycStatus
  const kycMeta = showKyc ? getKycStatusMeta(resolvedKyc) : null

  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" alignItems="center">
      <Chip
        size={size}
        icon={
          isEnabled ? (
            <CheckCircleOutline sx={{ fontSize: '16px !important' }} />
          ) : (
            <PauseCircleOutline sx={{ fontSize: '16px !important' }} />
          )
        }
        label={isEnabled ? `${practitionerLabel} Active` : `${practitionerLabel} Disabled`}
        color={isEnabled ? 'success' : 'warning'}
        variant={isEnabled ? 'filled' : 'outlined'}
        sx={{ fontWeight: 600 }}
      />
      {kycMeta && (
        <Chip size={size} label={kycMeta.label} color={kycMeta.color} variant="outlined" />
      )}
      {!isEnabled && (
        <Chip
          size={size}
          variant="outlined"
          label="Bookings held until re-enabled"
          sx={{ color: 'text.secondary' }}
        />
      )}
    </Stack>
  )
}
